<template>
  <div class="success-component">
    <QIcon name="icon-extra-smartphone" color="accent" size="100px" />
    <section>
      <h3>{{ $filters.whitespacedPunctuation($t("ETAB.PAGES.EXTRA.EXTRA_SELECTED_MODAL.@CONGRATS_TITLE")) }}</h3>
      <p>{{ $filters.whitespacedPunctuation($t("ETAB.PAGES.EXTRA.EXTRA_SELECTED_MODAL.@CONGRATS_TEXT")) }}</p>
    </section>
    <section>
      <h3>{{ $filters.whitespacedPunctuation($t("ETAB.PAGES.EXTRA.EXTRA_SELECTED_MODAL.@FOLLOW_UP_TITLE")) }}</h3>
      <p>{{ $t("ETAB.PAGES.EXTRA.EXTRA_SELECTED_MODAL.@FOLLOW_UP_TEXT") }}</p>
    </section>
  </div>
</template>

<script>
  export default {};
</script>
